import {useState, useEffect, useRef, useCallback} from "react";
import {inject, observer} from "mobx-react";
import {db} from "../../../../firebase/Firebase";
import {useSnackbar} from "notistack";
import Alerts from "../../../../palette/Alerts";
import Geocode from "react-geocode"
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {AdjustableColumns, LayoutChild} from "../../../../palette/Palette";
import VerticalSpace from "../../../../palette/VerticalSpace";
import ListCities from "./ListCities";
import RestrictMap from "./RestrictMap";
import {Animated} from "react-animated-css";

const {REACT_APP_GM_KEY} = process.env
Geocode.setApiKey(REACT_APP_GM_KEY);
Geocode.setLanguage("en");
Geocode.setRegion("es");

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function RestrictZones(props) {

    const {DataStore, ControlStore} = props

    const {companyName, idCompany,} = DataStore
    const {routesSchedulesControl} = ControlStore

    const [citiesList, setCitiesList] = useState([])
    const [selectedItemKeys, setSelectedItemKeys] = useState(null)
    const [coordinates, setCoordinates] = useState(null)
    const [city, setCity] = useState('')
    const [ID, setID] = useState(null)

    const {enqueueSnackbar} = useSnackbar();
    const isMounted = useMountedState()

    useEffect(() => {
        const GetRoutes = async () => {
            const citiesArray = []
            const newArray = []
            let ID = 0
            await db.collection(companyName).doc(idCompany).collection('Data-Routes').get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        newArray.push(doc.data().origin)
                        newArray.push(doc.data().destination)
                    });
                    const newArr = newArray.filter((el, index) => newArray.indexOf(el) === index)
                    newArr.forEach(item => {
                        ID = ID + 1
                        const newObj = {ID: ID, city: item}
                        citiesArray.push(newObj)
                    })

                    setSelectedItemKeys([citiesArray[0]?.ID])
                    setCity(citiesArray[0]?.city)
                    setCitiesList(citiesArray)

                    if (citiesArray.length === 0) {
                        return
                    }

                    Geocode.fromAddress(citiesArray[0]?.city).then(
                        response => {
                            const {lat, lng} = response.results[0].geometry.location;
                            setCoordinates({latitude: lat, longitude: lng})
                        },
                        () => {
                            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                        }
                    );
                })
        }
        if (isMounted()) {
            GetRoutes().catch((e) => {
                console.log(e)
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
            })
        }
    }, [companyName, idCompany, isMounted])

    const onClickCity = (e) => {
        setSelectedItemKeys([e.itemData.ID])
        setID(e.itemData.ID)
        setCity(e.itemData.city)
        Geocode.fromAddress(e.itemData.city).then(
            response => {
                const {lat, lng} = response.results[0].geometry.location;
                setCoordinates({latitude: lat, longitude: lng})
            },
            () => {
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
            }
        );
    }

    return (
        <>
            {routesSchedulesControl ?
                <AdjustableColumns color={'blues'} listWith={350}>
                    <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                        <ListCities data={citiesList} selectedItemKeys={selectedItemKeys} onClickCity={onClickCity}
                                    ID={ID}/>
                    </Animated>
                    {coordinates &&
                    <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                        <RestrictMap coordinates={coordinates} companyName={companyName} idCompany={idCompany}
                                     city={city}/>
                    </Animated>
                    }
                </AdjustableColumns> :
                <LayoutChild percent={95} margin='auto' top={25}>
                    <Alerts severity={'warning'} body={'¡Debe crear las rutas y horarios!'}/>
                </LayoutChild>
            }
        </>
    )
}

export default inject('DataStore', 'ControlStore')(observer(RestrictZones));